import React from "react";
import styled from "styled-components";
import { rgba, parseToRgb } from "polished";
import { MdInfoOutline as MdInfo } from "react-icons/md";

import { ListItem } from "../ListItems";
import { ChapterMenuDiv } from "./styles";
import { Book } from "api/typedefs/Bible";
import { ChapterCtx, StateChapter } from "components/Chapter/ChapterContainer";
import { useScriptureRouting } from "components/Bible/useScriptureRouting";

export const ChapterButton = styled.div<{ selected: boolean }>`
  cursor: pointer;
  font-size: 1em;
  height: 32px;
  width: 32px;
  border: solid 1px #c9c9c9;
  border-radius: 2px;
  margin: 0 4px 4px 0;
  transition: all 0.5s ease;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.primaryText};

  ${({ theme }) =>
    theme.darkMode
      ? `&:hover {
      border-color: white;
      background-color: rgba(255, 255, 255, 0.3);
      color: white;
    }`
      : `&:hover {
      border-color: ${theme.computedPrimary};
      background-color: ${theme.hightlightColor};
      color: white;
    }`}

  ${({ selected, theme }) =>
    selected &&
    (theme.darkMode
      ? `border-color: white;
         background-color: rgba(255, 255, 255, 0.3);
         color: white;`
      : `border-color: ${theme.computedPrimary};
          background-color: ${rgba({
            ...parseToRgb(theme.computedPrimary),
            alpha: 0.1
          })};
          color: ${theme.computedPrimary};`)}
`;

interface ChapterButtonProps {
  book: Book;
  chapter: ChapterCtx;
  handleChapterClick: (chapterInfo: {
    bibleId: string;
    chapterId: string;
  }) => void;
}

const ChapterButtons = ({ book, handleChapterClick }: ChapterButtonProps) => {
  const { chapterId: currentChapterId } = useScriptureRouting();
  return (
    <>
      {book.chapters
        .sort((a, b) => a.position - b.position)
        .map((chapterItem: StateChapter) => (
          <ChapterButton
            onClick={() =>
              handleChapterClick({
                chapterId: chapterItem.id,
                bibleId: chapterItem.bibleId
              })
            }
            key={chapterItem.id}
            selected={chapterItem.id === currentChapterId}
          >
            {chapterItem.number === "intro" ? (
              <MdInfo size={24} />
            ) : (
              chapterItem.number
            )}
          </ChapterButton>
        ))}
    </>
  );
};

interface BookChapterListProps {
  book: Book;
  bookId: string | null;
  chapter: ChapterCtx;
  handleBookClick: (bookId: string) => void;
  handleChapterClick: (chapterInfo: {
    bibleId: string;
    chapterId: string;
  }) => void;
  selectedBookId: string;
}

export const BookChapterList = ({
  book,
  bookId,
  chapter,
  handleBookClick,
  handleChapterClick,
  selectedBookId
}: BookChapterListProps) => (
  <>
    <ListItem
      onClick={() => handleBookClick(book.id)}
      id={book.id}
      active={bookId === book.id}
    >
      {book.name}
    </ListItem>
    {selectedBookId === book.id && (
      <ChapterMenuDiv key={`${book.id}-chapters`}>
        {selectedBookId === book.id ? (
          <ChapterButtons
            book={book}
            chapter={chapter}
            handleChapterClick={handleChapterClick}
          />
        ) : null}
      </ChapterMenuDiv>
    )}
  </>
);
